import { mutationOptions, queryOptions } from '@tanstack/react-query';
import { checkout, getCheckoutOpts } from '..';
import { AxiosError } from 'axios';
import { queryClient } from 'merchant-api';
import { getCurrentAppOpts } from 'merchant-api/unified';

export interface BankInfo {
  bankName: string;
  accountNumber: string;
  routingNumber: string;
}

interface UpdateBankInfoRequest {
  checkoutUuid: string;
  bankName: string;
  accountNumber: string;
  routingNumber: string;
}

const getBankInfoData = (checkoutUuid: string) => checkout.get<BankInfo>(`/v1/bank-info/${checkoutUuid}`).then((res) => res.data);

export const getBankInfoOpts = (checkoutUuid: string) =>
  queryOptions<BankInfo>({
    queryKey: ['bankInfo'],
    queryFn: () => getBankInfoData(checkoutUuid),
  });

const updateBankInfo = async (data?: UpdateBankInfoRequest) => {
  if (!data) {
    const app = await queryClient.fetchQuery(getCurrentAppOpts(['APPROVED']));
    if (!app?.id) throw new Error('No APPROVED current application found');
    const { id } = app;
    const checkoutData = await queryClient.fetchQuery(getCheckoutOpts(id));
    const checkoutUuid = checkoutData?.checkoutUuid;
    const bankData = await queryClient.fetchQuery(getBankInfoOpts(checkoutUuid));
    data = {
      checkoutUuid: checkoutUuid,
      bankName: bankData.bankName,
      accountNumber: bankData.accountNumber,
      routingNumber: bankData.routingNumber,
    };
  }
  return checkout.post<unknown>('/v1/bank-info/update-bank-details', data).then((res) => res.data);
};

export const updateBankInfoOpts = () =>
  mutationOptions<any, AxiosError, UpdateBankInfoRequest | undefined>({
    mutationFn: updateBankInfo,
  });

export default updateBankInfo;
